import {createSlice} from '@reduxjs/toolkit'

const initialCommonState: ICommonState = {
  listLoading: false,
  actionsLoading: false,
  error: '',
  statistics: [],
  inspectionsCalenderData: [],
  dashboardAnalytics: [],
  billingDetails: null,
}

export interface ICommonState {
  listLoading: boolean
  actionsLoading: boolean
  error: string
  statistics: []
  inspectionsCalenderData: []
  dashboardAnalytics: []
  billingDetails: IBillingDetails | null
}

export interface IBillingDetails {
  billing_name: string
  billing_email: string
  country_code: string
  phone: string
  name: string
  company_registration_number: string
  vat_number: string
  address: string
}

export const callTypes = {
  list: 'list',
  action: 'action',
}

export const CommonSlices = createSlice({
  name: 'common',
  initialState: initialCommonState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false
      } else {
        state.actionsLoading = false
      }
    },
    startCall: (state, action) => {
      state.error = ''
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true
      } else {
        state.actionsLoading = true
      }
    },
    endCall: (state, action) => {
      state.error = ''
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false
      } else {
        state.actionsLoading = false
      }
    },
    dashboardStatistics: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.statistics = action.payload
    },
    dashboardAnalytics: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.dashboardAnalytics = action.payload.statistics
    },
    inspectionsCalenderData: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.inspectionsCalenderData = action.payload.inspections
    },
    resetCalenderData: (state, action) => {
      state.inspectionsCalenderData = action.payload
    },
    resetDashboardData: (state, action) => {
      state.listLoading = false
      state.actionsLoading = false
      state.error = ''
      state.statistics = action.payload
      state.inspectionsCalenderData = []
    },
    billingDetails: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.billingDetails = action.payload
    },
    resetBillingDetails: (state) => {
      state.billingDetails = null
    },
  },
})

export const {catchError, startCall, endCall} = CommonSlices.actions
